<script>
    import { onMount, onDestroy } from 'svelte'
    import { goto } from '@sveltech/routify'
    import KeyDisplay from '../../components/KeyDisplay.svelte'
    import { keyStore } from '../../stores/keyStore'
    import KeyService from '../../helpers/KeyService'

    import { applicationConfigStore } from '../../stores/applicationConfigStore'

    let apiKeys

    onMount(async () => {
        const configs = await KeyService.get()
    })

    const unsubscribeKeys = keyStore.subscribe((keys) => {
        apiKeys = keys
        // if (keys.length) {
        //     keys.forEach((key) => {
        //         if (key.type === 'chat') {
        //             chatKey = key
        //             return key
        //         } else {
        //             hypetrainKey = key
        //         }
        //     })
        // }
    })

    onDestroy(unsubscribeKeys)

    function handleClick(data) {
        const { url } = data
        $goto(`../../${url}`)
        return false
    }

    async function generateOrUpdateKeys(method, type) {
        if (method === 'create') {
            await KeyService.create({ type })
            return false
        } else {
            const config = apiKeys.find((item) => {
                return item.type === type
            })
            await KeyService.update(config)
        }
    }
</script>

<div class="px-4 sm:px-6 lg:px-8">
    <div class="pb-2 border-b border-gray-200">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
            OBS Browser Sources
        </h3>
    </div>

    <div class="mt-4">
        <div class="max-w-6xl mx-auto">
            <h2 class="text-base leading-4 font-light text-cool-gray-900 mb-4">
                Simply drag the OBS icon below onto the scene to add the URL's
                as a browser source.
            </h2>
            <p />

            <KeyDisplay
                keys={apiKeys}
                handleKeyGeneration={generateOrUpdateKeys} />
        </div>
    </div>
</div>

<style>
</style>
